import Other from './other'
import Indicators from './indicators'
import LeadPolling from './LeadPolling'

export default {
  Other,
  Indicators,
  LeadPolling,
}
